import type { RewardShoppingProps } from './types'

import { formatCommaNumber } from '@tmap-web-lib/utils'
import Image from 'next/image'

import iconRewardShopping from '@/assets/images/icon-reward-shopping.png'
import IcArrowRight from '@/assets/tmds-icons/ic_arrow_right.svg?component'

import * as styles from './rewardShopping.css'

/** 혜택 태그에 표시할 문구 (디자인 고정값) */
const BENEFIT_TAG_TEXT = '최대 5만원 혜택'

const REWARD_AMOUNT_MAX = 999999

function formatRewardAmount(amount: number): string {
  if (amount > REWARD_AMOUNT_MAX) {
    return `${formatCommaNumber(REWARD_AMOUNT_MAX)}+`
  }
  return formatCommaNumber(amount)
}

function RewardShopping({ rewardPoint, benefitTagConfig, onClick }: RewardShoppingProps) {
  const isActivate = rewardPoint !== null && rewardPoint > 0
  const benefitText = benefitTagConfig?.text ?? BENEFIT_TAG_TEXT
  const showBenefitTag = benefitTagConfig === undefined || benefitTagConfig.isShow

  return (
    <div className={styles.wrapper}>
      <button
        className={styles.button}
        onClick={onClick}
      >
        {/* 왼쪽: 아이콘 + 타이틀 */}
        <div className={styles.leftSection}>
          <div className={styles.iconWrapper}>
            <Image
              className={styles.icon}
              src={iconRewardShopping}
              width={28}
              height={28}
              alt=""
            />
          </div>
          <div className={styles.titleWrapper}>
            <span className={styles.title}>리워드쇼핑</span>
          </div>
        </div>

        {/* 오른쪽: 혜택 태그(off) 또는 리워드 금액(on) + 화살표 */}
        <div className={styles.rightSection}>
          {isActivate ? (
            <span className={styles.rewardAmount}>
              <span className={styles.rewardAmountNumber}>{formatRewardAmount(rewardPoint)}</span>
              <span className={styles.rewardAmountLabel}>리워드</span>
            </span>
          ) : (
            showBenefitTag && (
              <div className={styles.benefitTag}>
                <span className={styles.benefitTagText}>{benefitText}</span>
              </div>
            )
          )}
          <IcArrowRight
            className={styles.arrowIcon}
            width={16}
            height={16}
          />
        </div>
      </button>
    </div>
  )
}

export { RewardShopping }
export type { RewardShoppingProps }
